import React from 'react';
import Box from '@mui/material/Box';

export type PopperPlacement =
  | 'bottom-start' | 'bottom-end' | 'bottom'
  | 'top-start' | 'top-end' | 'top'
  | 'left-start' | 'left-end'
  | 'right-start' | 'right-end';

export const ARROW_SIZE = 7;

function getArrowSx(
  placement: PopperPlacement,
  outerColor: string,
  innerColor: string,
) {
  const sz = ARROW_SIZE;
  const inner = sz - 1;

  const isBottom = placement.startsWith('bottom');
  const isTop = placement.startsWith('top');
  const isLeft = placement.startsWith('left');

  if (isBottom) {
    return {
      position: 'absolute' as const,
      top: -sz,
      width: sz * 2,
      height: sz,
      '&::before': {
        content: '""',
        display: 'block',
        width: 0,
        height: 0,
        borderLeft: `${sz}px solid transparent`,
        borderRight: `${sz}px solid transparent`,
        borderBottom: `${sz}px solid ${outerColor}`,
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '1px',
        left: '1px',
        width: 0,
        height: 0,
        borderLeft: `${inner}px solid transparent`,
        borderRight: `${inner}px solid transparent`,
        borderBottom: `${inner}px solid ${innerColor}`,
      },
    };
  }

  if (isTop) {
    return {
      position: 'absolute' as const,
      bottom: -sz,
      width: sz * 2,
      height: sz,
      '&::before': {
        content: '""',
        display: 'block',
        width: 0,
        height: 0,
        borderLeft: `${sz}px solid transparent`,
        borderRight: `${sz}px solid transparent`,
        borderTop: `${sz}px solid ${outerColor}`,
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '1px',
        left: '1px',
        width: 0,
        height: 0,
        borderLeft: `${inner}px solid transparent`,
        borderRight: `${inner}px solid transparent`,
        borderTop: `${inner}px solid ${innerColor}`,
      },
    };
  }

  if (isLeft) {
    return {
      position: 'absolute' as const,
      right: -sz,
      width: sz,
      height: sz * 2,
      '&::before': {
        content: '""',
        display: 'block',
        width: 0,
        height: 0,
        borderTop: `${sz}px solid transparent`,
        borderBottom: `${sz}px solid transparent`,
        borderLeft: `${sz}px solid ${outerColor}`,
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '1px',
        left: '0px',
        width: 0,
        height: 0,
        borderTop: `${inner}px solid transparent`,
        borderBottom: `${inner}px solid transparent`,
        borderLeft: `${inner}px solid ${innerColor}`,
      },
    };
  }

  return {
    position: 'absolute' as const,
    left: -sz,
    width: sz,
    height: sz * 2,
    '&::before': {
      content: '""',
      display: 'block',
      width: 0,
      height: 0,
      borderTop: `${sz}px solid transparent`,
      borderBottom: `${sz}px solid transparent`,
      borderRight: `${sz}px solid ${outerColor}`,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '1px',
      right: '0px',
      width: 0,
      height: 0,
      borderTop: `${inner}px solid transparent`,
      borderBottom: `${inner}px solid transparent`,
      borderRight: `${inner}px solid ${innerColor}`,
    },
  };
}

type Props = {
  placement: PopperPlacement;
  arrowRef: (el: HTMLSpanElement | null) => void;
  outerColor?: string;
  innerColor?: string;
};

export default function DropdownMenuArrow({
  placement,
  arrowRef,
  outerColor = '#d1d5db',
  innerColor = '#fff',
}: Props) {
  return (
    <Box
      component="span"
      ref={arrowRef}
      sx={getArrowSx(placement, outerColor, innerColor)}
    />
  );
}
